module.exports = __webpack_public_path__ + "static/sport/game-3.c486e26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport7/game-3.png
// module id = X5D+
// module chunks = 0